"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CheckoutAPI {
    client;
    constructor(client) {
        this.client = client;
    }
    async getCheckoutSettings(locationId) {
        return await this.client.get(`/locations/${locationId}/checkout-settings`);
    }
    async updateCheckoutSettings(locationId, updatedSettings) {
        return await this.client.patch(`/locations/${locationId}/checkout-settings`, updatedSettings);
    }
}
exports.default = CheckoutAPI;
//# sourceMappingURL=index.js.map